import { gql } from '@apollo/client';

const recentUpdatesNotificationBaseFragment = gql`
  fragment RecentUpdatesNotificationBaseFields on RecentUpdatesNotificationBase {
    Type
    Name
    NotificationDaysAgo
  }
`;

export default recentUpdatesNotificationBaseFragment;
